import { ContainerModule } from 'inversify';
import { domainModule } from '@framework/config/DI/domainModule';
import { configModule } from '@finsight/config/DI/configModule';
import { messageManagerModule } from './modules/messageManagerModule';
import { analyticsModule } from './modules/analyticsModule';
import { seoModule } from '@/finsight/application/DI/modules/seoModule';
import { DispatcherModule as UsersDispatcherModule } from '@users/json-rpc-dispatcher';
import { DispatcherModule as DmPortalDispatcherModule } from '@dm-portal/json-rpc-dispatcher';
import { DispatcherModule as FinsightWebDispatcherModule } from '@creditflowresearch/json-rpc-dispatcher/dispatcher-cfr';
import { DispatcherModule as FinsightStratsDispatcherModule } from '@creditflowresearch/json-rpc-dispatcher/dispatcher-finsight-strats';
import { SocketModule as FinsightSocketModule } from '@finsight/socket-client';
import { FileUploadModule as FinsightFileUploadModule } from '@finsight/file-upload';
import { DispatcherModule as CondorDispatcherModule } from '@condor/json-rpc-dispatcher';

export const rootModules: ContainerModule[] = [
  domainModule,
  configModule,
  messageManagerModule,
  analyticsModule,
  seoModule,
  UsersDispatcherModule,
  DmPortalDispatcherModule,
  FinsightWebDispatcherModule,
  FinsightStratsDispatcherModule,
  FinsightSocketModule,
  FinsightFileUploadModule,
  CondorDispatcherModule,
];

export const serverContainerModules = [
  ...rootModules,
];
